import { Option } from '@sapphire/result';
import {
  feotSettingFrom,
  QuotaFeaturesForm,
  Survey,
  SurveyFeot,
} from '@ps/survey-utils';

export interface FeotSwitchInput {
  readonly survey: Option<Survey>;
  readonly quotaFeatures: QuotaFeaturesForm;
}

export function hasFeotQuotaViolation({
  survey,
  quotaFeatures,
}: FeotSwitchInput): boolean {
  return survey.mapOr(false, (openSurvey) =>
    new SurveyFeot(openSurvey, feotSettingFrom(quotaFeatures)).isBelowQuota(),
  );
}
